/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/timeline_marker.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.TimelineMarker
 */
export interface TimelineMarker {
    /**
     * @generated from protobuf field: optional string event_id = 1;
     */
    event_id?: string;
    /**
     * @generated from protobuf field: optional string event_type = 2;
     */
    event_type?: string;
    /**
     * @generated from protobuf field: optional int32 event_timestamp = 3;
     */
    event_timestamp?: number;
    /**
     * @generated from protobuf field: optional string player_team_id = 4;
     */
    player_team_id?: string;
    /**
     * @generated from protobuf field: optional string player_name = 5;
     */
    player_name?: string;
    /**
     * @generated from protobuf field: optional string home_team_id = 6;
     */
    home_team_id?: string;
    /**
     * @generated from protobuf field: optional string away_team_id = 7;
     */
    away_team_id?: string;
    /**
     * @generated from protobuf field: optional string asset_id = 8;
     */
    asset_id?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class TimelineMarker$Type extends MessageType<TimelineMarker> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.TimelineMarker", [
            { no: 1, name: "event_id", kind: "scalar", localName: "event_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "217efc47-efef-46db-b09e-5f12663295ba", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Id of timeline marker in uuid format." } },
            { no: 2, name: "event_type", kind: "scalar", localName: "event_type", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Home Run", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Type of timeline marker." } },
            { no: 3, name: "event_timestamp", kind: "scalar", localName: "event_timestamp", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "336000", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Milliseconds timestamp that the timeline marker locates in program" } },
            { no: 4, name: "player_team_id", kind: "scalar", localName: "player_team_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "12", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "External team id of the player in timeline marker" } },
            { no: 5, name: "player_name", kind: "scalar", localName: "player_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Christian Walker", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Name of the player in timeline marker" } },
            { no: 6, name: "home_team_id", kind: "scalar", localName: "home_team_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "12", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "External home team id of the program" } },
            { no: 7, name: "away_team_id", kind: "scalar", localName: "away_team_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "14", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "External away team id of the program" } },
            { no: 8, name: "asset_id", kind: "scalar", localName: "asset_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "LIVE_91485541", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Asset id of the program" } }
        ]);
    }
    create(value?: PartialMessage<TimelineMarker>): TimelineMarker {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TimelineMarker>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TimelineMarker): TimelineMarker {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string event_id */ 1:
                    message.event_id = reader.string();
                    break;
                case /* optional string event_type */ 2:
                    message.event_type = reader.string();
                    break;
                case /* optional int32 event_timestamp */ 3:
                    message.event_timestamp = reader.int32();
                    break;
                case /* optional string player_team_id */ 4:
                    message.player_team_id = reader.string();
                    break;
                case /* optional string player_name */ 5:
                    message.player_name = reader.string();
                    break;
                case /* optional string home_team_id */ 6:
                    message.home_team_id = reader.string();
                    break;
                case /* optional string away_team_id */ 7:
                    message.away_team_id = reader.string();
                    break;
                case /* optional string asset_id */ 8:
                    message.asset_id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TimelineMarker, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string event_id = 1; */
        if (message.event_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.event_id);
        /* optional string event_type = 2; */
        if (message.event_type !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.event_type);
        /* optional int32 event_timestamp = 3; */
        if (message.event_timestamp !== undefined)
            writer.tag(3, WireType.Varint).int32(message.event_timestamp);
        /* optional string player_team_id = 4; */
        if (message.player_team_id !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.player_team_id);
        /* optional string player_name = 5; */
        if (message.player_name !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.player_name);
        /* optional string home_team_id = 6; */
        if (message.home_team_id !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.home_team_id);
        /* optional string away_team_id = 7; */
        if (message.away_team_id !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.away_team_id);
        /* optional string asset_id = 8; */
        if (message.asset_id !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.asset_id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.TimelineMarker
 */
export const TimelineMarker = new TimelineMarker$Type();
